export const mounted = {
  id: 'vbm-mounted',
  definition: {
    inserted: function (el, binding) {
      const { callback, index } = binding.value
      callback(el, index)
    }
  }
}
